module.exports = __webpack_public_path__ + "assets/img/terminalPic9_app.99a7d562.png";